import { useScaffold } from "@Light/scaffold";
import clsx from "clsx";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { StatusBox } from "./StatusBox";

export type SuccessBoxProps = {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  children?: React.ReactNode;
};

export const SuccessBox: React.FC<SuccessBoxProps> = ({
  title,
  subtitle,
  children,
}) => {
  const scaffold = useScaffold();
  return (
    <StatusBox
      icon={
        <CheckCircleIcon
          className={clsx("w-1/12", scaffold.page.colors.text.success)}
        />
      }
      className={clsx(
        scaffold.page.colors.border.success,
        scaffold.page.colors.background.success,
      )}
      title={title}
      subtitle={subtitle}
    >
      {children}
    </StatusBox>
  );
};
